let _ = t => t,
  _t;
import styled from 'styled-components';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { CRM_SUITE_STARTER_BUNDLE, HUBSPOT_FREE } from 'self-service-api/constants/ApiNames';
import { CUSTOMER_FEEDBACK_SURVEYS, DEAL_TAGS, KNOWLEDGE_BASE, TICKET_TAGS } from 'self-service-api/constants/Features';
import { API_LIMITED_ACCESS, API_NO_ACCESS } from 'self-service-api/constants/FreeUserAccessValues';
import HubMap from 'self-service-api/constants/HubMap';
import { productLineToHub } from 'self-service-api/constants/ProductLineToHub';
import * as PurchaseTypes from 'self-service-api/constants/PurchaseTypes';
import { getProductLineFromApiNameString } from '../_core/features/FeaturesUtils';
import breakpoint from '../_core/utils/responsiveBreakpoints';
import FeatureTableCell from './FeatureTableCell';
import FeatureTableUserIcon from './FeatureTableUserIcon';
import TranslatedFeature from './TranslatedFeature';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const seatsFreeUserAccessLevelOverrides = {
  [KNOWLEDGE_BASE]: API_NO_ACCESS,
  [CUSTOMER_FEEDBACK_SURVEYS]: API_NO_ACCESS,
  [DEAL_TAGS]: API_NO_ACCESS,
  [TICKET_TAGS]: API_NO_ACCESS
};
const isSeatBased = productLine => {
  return HubMap[productLineToHub[productLine]].merchPurchaseType === PurchaseTypes.SEAT_BASED;
};
const HeadContentWrapper = styled.div.withConfig({
  displayName: "FeatureRow__HeadContentWrapper",
  componentId: "sc-1gqtb9j-0"
})(["display:flex;justify-content:start;margin-left:42px;", ";"], breakpoint.tabletPortrait(_t || (_t = _`
    margin-left: 32px;
  `)));
const FeatureRow = ({
  feature,
  levels,
  canViewNewSeats,
  onlyShowCurrentLongLimit = false,
  productLine
}) => {
  const accessLevel = canViewNewSeats && seatsFreeUserAccessLevelOverrides[feature.shortName] || feature.freeUserAccessLevel;
  const showUserIcon = (productLine ? isSeatBased(productLine) : feature.productApiNames.some(apiName => {
    if (apiName === CRM_SUITE_STARTER_BUNDLE || apiName === HUBSPOT_FREE) {
      return false;
    }
    const localProductLine = getProductLineFromApiNameString(apiName);
    return isSeatBased(localProductLine);
  })) && (accessLevel === API_LIMITED_ACCESS || accessLevel === API_NO_ACCESS);
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("th", {
      className: "p-all-3",
      children: /*#__PURE__*/_jsxs(HeadContentWrapper, {
        children: [/*#__PURE__*/_jsx("span", {
          children: showUserIcon && /*#__PURE__*/_jsx(FeatureTableUserIcon, {
            freeUserAccess: accessLevel,
            productLine: productLine,
            canViewNewSeats: canViewNewSeats
          })
        }), /*#__PURE__*/_jsx("span", {
          style: {
            cursor: 'help',
            textAlign: 'left'
          },
          children: /*#__PURE__*/_jsx(UITooltip, {
            use: "longform",
            title: /*#__PURE__*/_jsx(TranslatedFeature, {
              feature: feature,
              attribute: "description"
            }),
            children: /*#__PURE__*/_jsx("div", {
              tabIndex: -1,
              style: {
                fontWeight: 'normal'
              },
              children: /*#__PURE__*/_jsx(TranslatedFeature, {
                feature: feature,
                attribute: "name"
              })
            })
          })
        })]
      })
    }), levels && levels.map(level => {
      return /*#__PURE__*/_jsx(FeatureTableCell, {
        feature: feature,
        productLevel: level,
        levelIndex: levels.indexOf(level),
        onlyShowCurrentLongLimit: onlyShowCurrentLongLimit
      }, `${feature.featureId}-${feature.displayName}-${level}`);
    })]
  }, feature.featureId);
};
export default FeatureRow;